import { Component, type ReactNode } from 'react'
import { Loader2 } from 'lucide-react'

export class PdfErrorBoundary extends Component<
  { children: ReactNode; fallback?: ReactNode },
  { hasError: boolean }
> {
  constructor(props: { children: ReactNode; fallback?: ReactNode }) {
    super(props)
    this.state = { hasError: false }
  }

  static getDerivedStateFromError() {
    return { hasError: true }
  }

  componentDidCatch(error: Error) {
    if (error.message?.includes('sendWithPromise') || error.message?.includes('WorkerTransport')) {
      console.warn('PDF.js worker transport error caught (likely StrictMode):', error.message)
    } else {
      throw error
    }
  }

  componentDidUpdate(prevProps: { children: ReactNode }) {
    if (this.state.hasError && prevProps.children !== this.props.children) {
      this.setState({ hasError: false })
    }
  }

  render() {
    if (this.state.hasError) {
      return this.props.fallback || (
        <div className="flex items-center justify-center p-8">
          <Loader2 className="h-6 w-6 animate-spin text-[var(--text-secondary)]" />
        </div>
      )
    }
    return this.props.children
  }
}
